import { render, staticRenderFns } from "./search-list.vue?vue&type=template&id=edb09d70&scoped=true&"
import script from "./search-list.vue?vue&type=script&lang=js&"
export * from "./search-list.vue?vue&type=script&lang=js&"
import style0 from "./search-list.vue?vue&type=style&index=0&id=edb09d70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb09d70",
  null
  
)

export default component.exports